import React, { useCallback, useContext, useEffect, useMemo, useState } from 'react'
import styled, { css } from 'styled-components'

import Notification from 'rc-notification';
import Container from '../Container'
// import Logo from '../Logo'
import { Badge, DatePicker, Divider, Input, message, notification,  Popover,  Radio,  Space,  Switch, Tag } from 'antd';
import locale from 'antd/es/date-picker/locale/zh_CN';
// import fecha from 'fecha'
import Parse from 'parse'

import store from '../../state'
import moment from 'moment'
import { MenuOutlined,WechatOutlined } from '@ant-design/icons'
// import Nav from './components/Nav'
import { useStore } from '../../state/use-store';
// import axios from 'axios'
// import sleep from 'sleep-promise'
import { Drawer, Button, Modal } from 'antd'; 
// import useModal from 'antd/lib/modal/useModal';
import useDrawer from '../../hooks/useDrawer';
// import {  useTokenInfo } from '../../hooks/useArticles';
import _ from 'lodash'
import { useHistory } from 'react-router-dom';
import Articles,{Context} from '../../contexts/Articles';
import { backgroundStyle, getComment, getContentTextOfArticle, getThemeData, isDarkMode,   openParsedLink, parseTopicId, textColorStyle } from '../../utils/util';
// import useColumns from '../../hooks/useColumns';
import copy from 'copy-to-clipboard'
// import useWaterMark from '../../hooks/useWaterMark';
import DigestSwitch from '../DigestSwitch';
import {AiFillLike, AiOutlineAppstore, AiOutlineFieldTime, AiOutlineHistory, AiOutlineLike, AiOutlineMessage, AiOutlineUser} from 'react-icons/ai'
import theme from '../../theme';
import { usePageRefreshTime } from '../../contexts/Articles/Articles';
import { mobile } from '../../utils/media';
import Marquee from 'react-fast-marquee';
import Spacer from '../Spacer';
import sleep from 'sleep-promise'

export const LimitedWarningMarquee:React.FC = ()=>{
  return <><Marquee speed={50}>
  </Marquee> 
  <Spacer size='sm'/>
  </>
}
const UrlParseResult = Parse.Object.extend('UrlParseResult')
// import {Context as WaterMarkContext} from '../../contexts/WaterMark';
// import {Modal} from 'antd';
 
// const TodoItem = 
let oldActivity = [
 
]
let tags = [ 
].map(t=>{
  if(t.title.startsWith('%')){
    t.title = decodeURIComponent(t.title)
  }
  return t
})

let ships = [
   
]
// tags = _.uniqBy(tags,t=>t.hashtag_id)


const MenuItem:React.FC<{logo?:any,title:string,onClick?:()=>void,count?:number}> = ({logo,title,onClick,count})=>{
    return <>  <Badge count={count}  style={{ backgroundColor: theme.color.primary.main }} > 
        <div style={{display:'flex',flexDirection:'column',alignItems:'center',cursor:'pointer',...textColorStyle()}} onClick={onClick} >
        {logo}
        {title}
      </div>
    </Badge>
    </>
}

// async function parseLink(url:string){
//   try{
    
//     message.info('解析中...')
//     let topicId = await Parse.Cloud.run('parseUrl',{url})
   
//     return topicId
//      // history.push('/article/'+topicId) 
//     // 在新链接中打开
    
//   }catch(e){
//     console.error('parseLink e',e)
//   }
// }


export async function parseLinkAndOpen(link:string){
     
    
}

const TopBar: React.FC = () => {
  
  return (
    <StyledTopBar>
      <Container size="lg">
        <StyledTopBarInner>
         
        </StyledTopBarInner>
      </Container>
      
    </StyledTopBar>
  )
}

const StyledGridItem = styled.div`
  /* color:#107459; */
  /* margin-right:10px; */
  height: 80px;
  width: 100%;
  // background: ${props=>isDarkMode()?'black':'white'};
  display: flex;
  flex-direction: column;
  text-align: center;
  align-items: center;
  justify-content: center;
  word-break: break-all;
  &:hover { 
    cursor: pointer; 
  }
  position: relative;
`

export const StyledTopBar = styled.div`
  /* position: relative; */
  width: 100%;
  flex-wrap: wrap;
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px; 
  z-index: 100;
  
`

export const StyledTopBarInner = styled.div`
  align-items: center;
  display: flex;
  height: ${props => props.theme.topBarSize}px;
  justify-content: space-between;
  max-width: ${props => props.theme.siteWidth}px;
  color: white;
  background: ${theme.color.primary.main};
  // box-shadow: 0 1px ${props=>isDarkMode()?'transparent':'#ecf0f5'};
  // border-bottom-width: 0px;
  overflow: hidden;
  ${mobile(css`
    border-radius: 0px;
  `)};
`

export default TopBar